export const isAuth = () => {
  if (localStorage.getItem("accesstokenhotelparkmall")) return true;
  return false;
};
